import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { BlogAuthor } from '@shared/models/blog-author.model';
import { BlogService } from '../services/blog.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthorResolver  {
  constructor(private blogService: BlogService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<BlogAuthor> | Promise<BlogAuthor> | BlogAuthor {
    if (route.queryParams?.index) {
      this.router.navigate([`author/${route.paramMap.get('slug')}/page/${route.queryParams.index}`]);
    }

    return this.blogService.getAuthorBySlug(route.paramMap.get('slug'));
  }
}
